<script setup lang="ts">

import {CurrencyDisplay, formatting, Models, useLocalization, useOrderViewContext} from "@hantera/portal-app";
import {computed} from "vue";

const props = defineProps<{
  orderLine: Models.Graph.OrderLine
}>();

const t = useLocalization('components.order.orderLine.details');
const orderViewContext = useOrderViewContext();

const orderLineTotal = computed(() => {
  return props.orderLine.unitPrice.mul(props.orderLine.quantity);
})

</script>

<template>
  <div class="detail">
    <div class="detail-label detail-unit-price">{{ t('unitPrice') }}</div>
    <div class="detail-value detail-unit-price">
      {{ formatting.currency(props.orderLine.unitPrice, orderViewContext.state.currencyCode, CurrencyDisplay.none) }}
    </div>
  </div>
  <div class="detail">
    <div class="detail-label detail-quantity">{{ t('quantity') }}</div>
    <div class="detail-value detail-quantity">
      {{ formatting.number(props.orderLine.quantity) }} pcs
    </div>
  </div>
  <div class="detail" style="grid-column: calc(var(--grid-column-offset) - 3)">
    <div class="detail-label detail-sum">{{ t('sum') }}</div>
    <div class="detail-value detail-sum">
      {{ formatting.currency(orderLineTotal, orderViewContext.state.currencyCode, CurrencyDisplay.none) }}
    </div>
  </div>
</template>

<style scoped>

</style>